import React from 'react';
import { string, node, number, oneOfType } from 'prop-types';
import * as Styled from 'library/components/card/styles';

const Card = ({
  children,
  width,
  height,
  className,
  borderColor,
  ...props
}) => {
  return (
    <Styled.Body
      width={width}
      height={height}
      className={className}
      borderColor={borderColor}
      {...props}
    >
      {children}
    </Styled.Body>
  );
};

Card.propTypes = {
  title: string,
  children: node,
  width: oneOfType([number, string]),
  height: oneOfType([number, string]),
  className: string,
  borderColor: string,
};

Card.defaultProps = {
  address: {},
};

export default Card;
